import Vue from 'vue'
import Vuex from 'vuex'

import faqs from './faqs'
import main from './main'
import enums from './enums'
import fighters from './fighters'
import map from './map'
import news from './news'
import products from './products'
import rappers from './rappers'
import riders from './riders'
import siteVersions from './site-versions'
import socials from './socials'
import feedbackSubjects from './subjects'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    faqs,
    main,
    enums,
    fighters,
    map,
    news,
    products,
    rappers,
    riders,
    siteVersions,
    socials,
    feedbackSubjects
  }
})
